/**
 * Open/Closed component.
 * @author Dayne Coulson-Hoffacker
 */
export default class OpenClosed {
  /**
   * Constructs a new Open/Closed instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    // Run open closed function
    this.checkOpenStatus()

  }

  checkOpenStatus() {
    const d = new Date()
    const date = d.getHours()
    const day = d.getDay()
    const element = document.querySelector('[data-component="open-closed"] span')
    // If greater than 8am and lower than 5.30pm and not on either a Saturday or Sunday
    if ((date > 8) && (date < 17.5) && (day != 0) && (day != 6)) {
      element.textContent = "Open Now"
    } else {
      element.textContent = "Closed Now"
    }
    setTimeout(this.checkOpenStatus, 3000)
  }
}



// WEBPACK FOOTER //
// ./components/open-closed/index.js